<header class="p-6 flex items-center justify-between max-w-screen-2xl mx-auto">
    <img class="h-10" src="/assets/logos/mailfox.svg" alt="{{ 'labels_mailfox' | translate }}" />
    <div class="drawer w-auto">
        <input
            id="my-drawer"
            type="checkbox"
            class="drawer-toggle"
            [checked]="isDrawerOpen()"
            (click)="onClick(true)" />
        <div class="drawer-content">
            <label for="my-drawer" class="btn btn-secondary drawer-button"
                ><img height="26" width="26" src="/assets/icons/menu.svg" alt=""
            /></label>
        </div>
        <div class="drawer-side z-50">
            <label for="my-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
            <ul class="menu p-4 py-6 w-80 min-h-full bg-base-100 text-base-content">
                <!-- Sidebar content  -->
                <img class="h-8 mb-4" src="/assets/logos/mailfox.svg" alt="{{ 'labels_mailfox' | translate }}" />
                <li (click)="onClick(false)" appIsAuthenticated>
                    <a class="btn btn-secondary mt-2" [routerLink]="appPages.DASHBOARD">
                        <img
                            src="/assets/icons/dashboard.svg"
                            height="24"
                            width="24"
                            alt="{{ 'buttons_dashboard' | translate }}" />
                        {{ 'buttons_dashboard' | translate }}</a
                    >
                </li>
                <li (click)="onClick(false)" appIsAuthenticated appLogout>
                    <a class="btn btn-ghost mt-2">
                        <img
                            src="/assets/icons/log-out.svg"
                            height="24"
                            width="24"
                            alt="{{ 'labels_logout' | translate }}" />
                        {{ 'labels_logout' | translate }}</a
                    >
                </li>
                <li (click)="onClick(false)" appIsNotAuthenticated>
                    <a class="btn btn-ghost mt-2" [routerLink]="appPages.LOGIN">
                        <img
                            src="/assets/icons/log-in.svg"
                            height="24"
                            width="24"
                            alt="{{ 'labels_login' | translate }}" />
                        {{ 'labels_login' | translate }}</a
                    >
                </li>
            </ul>
        </div>
    </div>
</header>
<hr />
